import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApprovalData } from 'src/types/plan.interface'

export interface SignalRState {
  approvalMessages: ApprovalData[]
  connectionStatus: 'disconnected' | 'connected' | 'connecting'
}

const initialState: SignalRState = {
  approvalMessages: [],
  connectionStatus: 'disconnected',
}
export interface SignalRPayloadAction {
  idPlusUserDivision: string
  wasApprovedOrRejected: boolean
}

export const signalRSlice = createSlice({
  initialState,
  name: 'signalR',
  reducers: {
    clearApprovalMessage: (
      state,
      action: PayloadAction<SignalRPayloadAction>
    ) => {
      if (action.payload.wasApprovedOrRejected) {
        state.approvalMessages = state.approvalMessages.filter(
          (message) =>
            message.approved !== undefined ||
            message.id + message.userDivision !==
              action.payload.idPlusUserDivision
        )
      }
    },
    clearMessages: (state) => {
      state.approvalMessages = []
    },
    setConnectionStatus: (
      state,
      action: PayloadAction<SignalRState['connectionStatus']>
    ) => {
      state.connectionStatus = action.payload
    },
    signalRApprovalMessageReceived: (
      state,
      action: PayloadAction<ApprovalData>
    ) => {
      const newMessage = action.payload
      const existingIndex = state.approvalMessages.findIndex(
        (msg) =>
          msg.id === newMessage.id &&
          msg.userDivision === newMessage.userDivision
      )
      if (existingIndex !== -1) {
        state.approvalMessages[existingIndex] = newMessage
      } else {
        state.approvalMessages.push(newMessage)
      }
    },
    startConnection: () => {},
  },
})

export const {
  clearApprovalMessage,
  clearMessages,
  setConnectionStatus,
  signalRApprovalMessageReceived,
  startConnection,
} = signalRSlice.actions
